export default "images/sunburst.png";